var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.name !== 'login')?[_c('cash-hero-navbar',{attrs:{"bright":true}})]:_vm._e(),_c('router-view')],2)}
var staticRenderFns = []

export { render, staticRenderFns }